<div [ngClass]="['app-pin', classDiv, color, height]">
  <div class="pin-code">
    <div class="base-item-container">
      <input
        *ngFor="let item of arrayInputs; let i = index"
        maxlength="1"
        appOnlyNumber
        attr.data-testid="pin-{{ i }}"
        [className]="'input-inside ' + classInputPin"
        [ngClass]="{
          'ml-0': item === 0,
          'ml-8': item !== 0,
          'n-allowed': alloweddDigit(i)
        }"
        [id]="'inp-' + i + '-' + idInput"
        (keyup)="onDigitInput($event, i)" />
    </div>
  </div>
</div>
